import $ from "jquery";

const header = $("header.header-section"),
  wpmlCurrentLangLink = $(".wpml-ls-current-language > a");

wpmlCurrentLangLink.on("click", function (e) {
  e.preventDefault();
});

$.fn.extend({
  toggleHtml: function (a, b) {
    return this.html(this.html() == b ? a : b);
  },
});

function fixedHeader(scrollBlock, header) {
  scrollBlock.on("scroll", function () {
    if (scrollBlock.scrollTop() > 5) {
      header.addClass("scrolled");
    } else {
      header.removeClass("scrolled");
    }
  });
}
fixedHeader($(document), header);

document.addEventListener(
  "wpcf7mailsent",
  function () {
    location = themeVars["thankYouPage"];
  },
  false
);
